import React, { useState, useEffect } from "react";

const Navbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const navbar = document.querySelector(".navbar");
      if (window.scrollY > 50) {
        navbar.style.backgroundColor = "rgba(255, 255, 255, 0.95)";
        navbar.style.boxShadow = "0 5px 20px rgba(0, 0, 0, 0.1)";
      } else {
        navbar.style.backgroundColor = "rgba(255, 255, 255, 0.9)";
        navbar.style.boxShadow = "none";
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  // Add this function to handle navigation clicks
  const handleNavClick = (e, targetId) => {
    e.preventDefault();

    // Close the mobile menu
    setIsMenuOpen(false);

    // Scroll to the section
    const section = document.getElementById(targetId);
    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  return (
    <nav className="navbar">
      <div className="container">
        <div className="nav-content">
          <a
            href="#home"
            className="logo"
            onClick={(e) => handleNavClick(e, "home")}
          >
            Design Edge
          </a>
          <ul
            className={`nav-links ${isMenuOpen ? "mobile-open" : ""}`}
          >
            <li>
              <a href="#home" onClick={(e) => handleNavClick(e, "home")}>
                Home
              </a>
            </li>
            <li>
              <a href="#about" onClick={(e) => handleNavClick(e, "about")}>
                About
              </a>
            </li>
            <li>
              <a
                href="#portfolio"
                onClick={(e) => handleNavClick(e, "portfolio")}
              >
                Portfolio
              </a>
            </li>
            <li>
              <a
                href="#services"
                onClick={(e) => handleNavClick(e, "services")}
              >
                Services
              </a>
            </li>
            <li>
              <a
                href="#testimonials"
                onClick={(e) => handleNavClick(e, "testimonials")}
              >
                Testimonials
              </a>
            </li>
            <li>
              <a href="#contact" onClick={(e) => handleNavClick(e, "contact")}>
                Contact
              </a>
            </li>
          </ul>
          <button className="mobile-menu-btn" onClick={toggleMenu}>
            <i className={`fas ${isMenuOpen ? "fa-times" : "fa-bars"}`}></i>
          </button>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
